// extracted by mini-css-extract-plugin
export default {"espaco_comerciante":"Comerciante_espaco_comerciante__upmX1","card_comerciante":"Comerciante_card_comerciante__iPl1e"};